import { useAudit } from "./use-audit";
import { AuditView } from "./view-audit";

/** Liga o ViewModel à View da aba Auditoria; o `ToastProvider` vem da casca do Painel. */
export function AuditScreen() {
  const vm = useAudit();

  return <AuditView {...vm} />;
}

export type * from "./types-audit";
